module.exports = __webpack_public_path__ + "img/Achievements.6bfe1ef5.svg";